export class GeoLocationResponse {
    BranchID: number;
    Branch: string;
    ClientRegionID: number;
    Region: string;
    RegionName: string;
    BranchCity: string;
    BranchState: string;
    ClientDistrictID: number;
    District: string;
    DistrictName: string;
    Longitude: number;
    Latitude: number;
    Distance: number;
    isSelected: boolean;

    constructor(init?: Partial<GeoLocationResponse>) {
        Object.assign(this, init);
    }
}
